var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { isBoolean } from 'lodash';
import dragula from 'dragula';
let Draggable = class Draggable extends Vue {
    constructor() {
        super(...arguments);
        this.internalItems = [];
        this.internalId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
        this.isResetting = false;
        this.drake = null;
    }
    get isIconHidden() {
        return !!(isBoolean(this.icon) && !this.icon);
    }
    get hasItemSlot() {
        return !!(this.$scopedSlots.item);
    }
    get isDisabled() {
        return this.disabled;
    }
    reset() {
        if (!this.drake) {
            return;
        }
        this.drake.destroy();
        this.isResetting = true;
        this.$nextTick(() => {
            this.isResetting = false;
            this.initialize();
        });
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        this.internalItems = [...this.items];
        this.initializeDrake();
    }
    initializeDrake() {
        const container = document.querySelector(`#atabix-draggable-${this.internalId}`);
        if (!container) {
            return;
        }
        this.drake = dragula([container], {
            revertOnSpill: true,
            invalid: this.isInvalid,
        });
        this.drake.on('drop', this.onDraggableDropped);
    }
    isInvalid(element, handle) {
        if (this.isDisabled) {
            return true;
        }
        if (this.isIconHidden) {
            return false;
        }
        if (!this.handleOnly) {
            return false;
        }
        return !(handle && handle.classList.contains('atabix-draggable__handle'));
    }
    onDraggableDropped(element, target) {
        const orderedItemIds = [];
        target.querySelectorAll('.atabix-draggable__item')
            .forEach((draggableElement) => {
            if (draggableElement.dataset.id) {
                orderedItemIds.push(draggableElement.dataset.id);
            }
        });
        const event = {
            items: orderedItemIds,
            reset: () => this.reset(),
        };
        this.$emit('reOrder', event);
    }
    itemsChanged() {
        this.reset();
    }
};
__decorate([
    Prop({ default: 'mdi-handle', type: String }),
    __metadata("design:type", Object)
], Draggable.prototype, "icon", void 0);
__decorate([
    Prop({ default: false, type: Boolean }),
    __metadata("design:type", Object)
], Draggable.prototype, "handleOnly", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], Draggable.prototype, "disabled", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], Draggable.prototype, "items", void 0);
__decorate([
    Watch('items'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Draggable.prototype, "itemsChanged", null);
Draggable = __decorate([
    Component({})
], Draggable);
export default Draggable;
